import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ability from '../../common/ability';
import { Action, Page } from '../../common/constants/pageAction';
import AzureAPIVmSizes from './AzureAPIVmSizes';
import AzureDailyUsage from './AzureDailyUsage';
import AzureOnboarding from './AzureOnboarding';
import AzurePrices from './AzurePrices';
import AzureRateCard from './AzureRateCard';
import AzureReservationOrders from './AzureReservationOrders';
import AzureSavingsPlanOrders from './AzureSavingsPlanOrders';

const AzureRoutes: React.FC = () => {
  const match = useRouteMatch();

  return (
    <div className="azure">
      <Switch>
        {/* Azure daily usage */}
        {ability.can(Action.View, Page.AzureDailyUsage) && (
          <Route exact path={`${match.path}/azure-daily-usage/:id`} component={AzureDailyUsage} />
        )}
        {ability.can(Action.View, Page.AzureDailyUsage) && (
          <Route exact path={`${match.path}/azure-daily-usage`} component={AzureDailyUsage} />
        )}

        {/* Azure rate card */}
        {ability.can(Action.View, Page.AzureRateCard) && (
          <Route exact path={`${match.path}/azure-rate-card/:id`} component={AzureRateCard} />
        )}
        {ability.can(Action.View, Page.AzureRateCard) && (
          <Route exact path={`${match.path}/azure-rate-card`} component={AzureRateCard} />
        )}

        {/* Azure rate card */}
        {ability.can(Action.View, Page.AzurePrices) && (
          <Route exact path={`${match.path}/azure-prices/:id`} component={AzurePrices} />
        )}
        {ability.can(Action.View, Page.AzurePrices) && (
          <Route exact path={`${match.path}/azure-prices`} component={AzurePrices} />
        )}

        {/* Azure api vm sizes */}
        {ability.can(Action.View, Page.AzureAPIVmSizes) && (
          <Route exact path={`${match.path}/azure-api-vm-sizes/:id`} component={AzureAPIVmSizes} />
        )}
        {ability.can(Action.View, Page.AzureAPIVmSizes) && (
          <Route exact path={`${match.path}/azure-api-vm-sizes`} component={AzureAPIVmSizes} />
        )}

        {/* Azure onboarding */}
        {ability.can(Action.View, Page.AzureOnboarding) && (
          <Route exact path={`${match.path}/azure-onboarding`} component={AzureOnboarding} />
        )}

        {/* Azure reservation orders */}
        {ability.can(Action.View, Page.AzureReservationOrders) && (
          <Route
            exact
            path={`${match.path}/azure-reservation-orders/:id`}
            component={AzureReservationOrders}
          />
        )}
        {ability.can(Action.View, Page.AzureReservationOrders) && (
          <Route exact path={`${match.path}/azure-reservation-orders`} component={AzureReservationOrders} />
        )}

        {/* Azure savings plan orders */}
        {ability.can(Action.View, Page.AzureSavingsPlanOrders) && (
          <Route
            exact
            path={`${match.path}/azure-savings-plan-orders/:id`}
            component={AzureSavingsPlanOrders}
          />
        )}
        {ability.can(Action.View, Page.AzureSavingsPlanOrders) && (
          <Route exact path={`${match.path}/azure-savings-plan-orders`} component={AzureSavingsPlanOrders} />
        )}

        {/* keep least always */}
        <Route path={`${match.path}/*`}>
          <Redirect to={`/404`} />
        </Route>
      </Switch>
    </div>
  );
};

export default AzureRoutes;
